"use strict";var __importDefault=function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StageItem=void 0;var react_1=__importDefault(require("react"));exports.StageItem=function(e){var t=e.item,r=e.className,e=e.styles;return react_1.default.createElement("li",{style:e,className:r},t)};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-alice-carousel/lib/views/StageItem.js
// module id = 608
// module chunks = 0